import { z } from "zod/v4";

export const trainingSlotSchema = z.object({
	court_ids: z.array(z.string().uuid()),
	day_of_week: z.number().int().min(0).max(6),
	end_time: z.string(),
	group_id: z.string().uuid(),
	id: z.string().uuid(),
	notes: z.string().nullable().optional(),
	start_time: z.string(),
});

export const createTrainingSlotSchema = z.object({
	court_ids: z.array(z.string().uuid()),
	day_of_week: z.number().int().min(0).max(6),
	end_time: z.string(),
	notes: z.string().nullable().optional(),
	start_time: z.string(),
});

export const updateTrainingSlotSchema = z.object({
	court_ids: z.array(z.string().uuid()).optional(),
	day_of_week: z.number().int().min(0).max(6).optional(),
	end_time: z.string().optional(),
	notes: z.string().nullable().optional(),
	start_time: z.string().optional(),
});

export const slotConflictSchema = z.object({
	day_of_week: z.number().int(),
	end_time: z.string(),
	group_id: z.string().uuid(),
	group_name: z.string(),
	slot_id: z.string().uuid(),
	start_time: z.string(),
});

export const conflictCheckResponseSchema = z.object({
	court_conflicts: z.array(slotConflictSchema),
	trainer_conflicts: z.array(slotConflictSchema),
});
